// ** Angular Imports
import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component } from '@angular/core';

// ** Third-Party Imports
import { TranslocoModule } from '@jsverse/transloco';

// ** Custom Component Imports
import { LogoComponent } from '@shared/components/core/logo/logo.component';

// ** Service Imports
import { WebsiteService } from '@shared/services/website.service';


@Component({
  selector: 'app-certifications',
  imports: [TranslocoModule, LogoComponent],
  standalone: true,
  templateUrl: './certifications.component.html',  
  styleUrl: './certifications.component.scss'
})

export class CertificationsComponent implements AfterViewInit {
  constructor(
    public _websiteService: WebsiteService,
    private route: ActivatedRoute
  ) {}

  language: string = 'en';

  ngAfterViewInit(): void {
    this.language = this._websiteService.language;

    this.route.queryParams.subscribe((params) => {
      const language = params['language'];
      if (language && language !== this.language) {
        this._websiteService.switchLanguage();
        this.language = language;
      }
    });
  }
}